export default {
  page: {
    title: "Pagina in costruzione",
  },
};
